export default "__VITE_ASSET__95c0caaf__"